import { Check, CirclePause, Wrench } from 'lucide-react';

import { humanizeStatus } from '@apps/web/components/automations/automation_form';
import {
    type AgentAutomationRunRead,
    type AgentAutomationStatus,
} from '@apps/web/components/automations/types';
import { Badge } from '@apps/web/components/ui/badge';

export function StatusBadge({
    status,
}: {
    readonly status: AgentAutomationStatus;
}) {
    if (status === 'active') {
        return (
            <Badge variant="success" className="gap-1">
                <Check className="size-3" />
                Active
            </Badge>
        );
    }
    if (status === 'paused') {
        return (
            <Badge variant="secondary" className="gap-1">
                <CirclePause className="size-3" />
                Paused
            </Badge>
        );
    }
    const exhaustive: never = status;
    return exhaustive;
}

export function RunStatusBadge({
    run,
}: {
    readonly run: AgentAutomationRunRead | null;
}) {
    if (run === null) {
        return <span className="text-muted-foreground">No runs</span>;
    }
    if (run.needs_tool_approval) {
        return (
            <Badge variant="secondary" className="gap-1">
                <Wrench className="size-3" />
                Needs approval
            </Badge>
        );
    }
    if (run.status === 'skipped') {
        return <Badge variant="secondary">Skipped</Badge>;
    }
    if (run.run_status === 'completed') {
        return <Badge variant="success">Completed</Badge>;
    }
    if (run.run_status === 'failed') {
        return <Badge variant="destructive">Failed</Badge>;
    }
    if (run.run_status === 'running') {
        return <Badge variant="secondary">Running</Badge>;
    }
    return (
        <Badge variant="outline">
            {humanizeStatus(run.run_status ?? run.status)}
        </Badge>
    );
}
